import { mergeStyles, getTheme } from '@fluentui/react';

const palette = getTheme().palette;
export const fullScreenStyle = mergeStyles({
    padding: '2px',
    borderRight: '1px solid rgba(0,0,0,0.05)',
    height: 'calc(100% - 5px)',
    width: 'calc(100% - 5px)',
    background: palette.neutralLighterAlt
});

export const fullScreenDarkStyle = mergeStyles({
    padding: '2px',
    borderRight: '1px solid rgba(0,0,0,0.05)',
    height: 'calc(100% - 5px)',
    width: 'calc(100% - 5px)',
    background: palette.neutralPrimary
});

export const hiddenFullScreenStyle = mergeStyles({
    display: 'none',
    borderRight: '1px solid rgba(0,0,0,0.05)',
    height: '100%',
    width: '100%',
    background: palette.neutralLighterAlt
});

export const loadingStyle = mergeStyles({
    height: '100%',
    display: 'flex',
    justifyContent: 'center'
});

export const pivotItemStyle = mergeStyles({
    padding: '0 0.8125rem',
    color: 'rgb(255, 50, 0)',
    position: 'absolute',
    right: '0',
    top: '1.2em',
    'z-index': '9'
});
